<template>
  <section class="row short-deck-range-for-street">
    <section class="col-lg-6">
      <short-deck-hand-range
        v-bind:ref="'player-' + playerIndex + '-' + playerStateIndex"
        v-bind:generalHands="player.states[playerStateIndex].generalHands"
        v-bind:weightToApplyToAddedHands="player.weightToApplyToAddedHands"
        v-bind:combosToAdd="player.combosToAdd"
        v-bind:disableAllSelectors="disableAllSelectors"
        v-bind:disableAllButGridSelector="playerStateIndex > 0"
        v-bind:canBeRemoved="false"
        v-on:clearRange="player.handleClearPlayerEvent(storeModuleName, $store, playerIndex, playerStateIndex)"
        v-on:addComboToCombosToAdd="player.handleAddComboToCombosToAddEvent(storeModuleName, $store, $event, playerIndex)"
        v-on:removeComboFromCombosToAdd="player.handleRemoveComboFromCombosToAddEvent(storeModuleName, $store, $event, playerIndex)"
        v-on:applyExactWeightToGeneralHands="player.handleApplyExactWeightToGeneralHandsEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:selectGeneralHand="player.handleSelectGeneralHandEvent(storeModuleName, $store, $event.generalHandString, $event.triggeredByMouseover, playerIndex, playerStateIndex)"
        v-on:deselectGeneralHand="player.handleDeselectGeneralHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:selectGeneralHands="player.handleSelectGeneralHandsEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:deselectGeneralHands="player.handleDeselectGeneralHandsEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:selectSpecificHand="player.handleSelectSpecificHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:deselectSpecificHand="player.handleDeselectSpecificHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setRangeToMatchGeneralHands="player.handleSetRangeToMatchGeneralHandsEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setRangeToMatchDoubleSlider="player.handleSetRangeToMatchDoubleSliderEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex, handRankings)"
        v-on:setRangeToMatchSpecificHandStrings="player.handleSetRangeToMatchSpecificHandStringsEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setSpecificHandAsManuallySet="player.handleSetSpecificHandAsManuallySetEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setSpecificHandAsNotManuallySet="player.handleSetSpecificHandAsNotManuallySetEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:applyExactWeightToGeneralHand="player.handleApplyExactWeightToGeneralHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setWeightOfSpecificHand="player.handleSetWeightOfSpecificHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setWeightToApplyToAddedHands="player.handleSetWeightToApplyToAddedHandsEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:finishedClickAndDrag="player.handleFinishedClickAndDrag(storeModuleName, $store, playerIndex, playerStateIndex)"
      >
        <slot name="left-header" slot="left-header"></slot>
        <value-to-bluff-ratio
          v-if="storeModuleName === 'guidedAnalysesCalling' && playerStateIndex > 0"
          slot="left-header"
          v-bind:generalHands="player.states[playerStateIndex].generalHands"
          v-bind:communityCards="presetCommunityCards.getArrayForState(player.states[playerStateIndex].name)"
        />
      </short-deck-hand-range>
    </section>
    <section class="col-lg-6">
      <five-card-hands-section
        v-if="playerStateIndex > 0"
        v-bind:playerState="player.states[playerStateIndex]"
        v-bind:hitPercentageUpToDate="player.states[playerStateIndex].isHitPercentageUpToDate(player, presetCommunityCards, presetHoleCards)"
        v-bind:showPercentagesOrCombos="true"
        v-bind:shortDeck="true"
        v-bind:authorized="authorized"
        v-on:setCheckedValueOfFiveCardHand="player.handleSetCheckedValueOfFiveCardHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:applyExactWeightToFiveCardHand="player.handleApplyExactWeightToFiveCardHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:toggleCollapsedValueOfFiveCardHandParent="player.handleToggleCollapsedValueOfFiveCardHandParentEvent(storeModuleName, $store, $event)"
        v-on:updateWeightOfFiveCardHand="player.handleUpdateWeightOfFiveCardHandEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:clearAllChecks="player.handleClearAllChecksEvent(storeModuleName, $store, playerIndex, playerStateIndex)"
        v-on:selectAllChecks="player.handleSelectAllChecksEvent(storeModuleName, $store, playerIndex, playerStateIndex)"
        v-on:setChecksToDefault="player.handleSetChecksToDefaultEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:setChecksBasedOnUserDefinedFilter="player.handleSetChecksBasedOnUserDefinedFilterEvent(storeModuleName, $store, $event, playerIndex, playerStateIndex)"
        v-on:fiveCardHandMouseover="handleFiveCardHandMouseover(storeModuleName, $store, playerIndex, playerStateIndex, $event)"
        v-on:fiveCardHandMouseleave="handleFiveCardHandMouseleave(storeModuleName, $store, playerIndex, playerStateIndex)"
      >
        <section
          v-if="simulateButton"
          slot="simulate-button"
          class="panel-footer"
        >
          <simulate-button
            v-on:simulate="$emit('simulate')"
          />
        </section>
        <five-card-hands-section-alerts
          slot="alerts"
          v-bind:textWhenFiveCardHandPercentagesArentUpToDate="textWhenFiveCardHandPercentagesArentUpToDate"
          v-bind:areFiveCardHandPercentagesUpToDate="player.states[playerStateIndex].areFiveCardHandPercentagesUpToDate(player, presetCommunityCards, presetHoleCards)"
        />
        <slot name="insights" slot="insights"></slot>
      </five-card-hands-section>
    </section>
  </section>
</template>

<script>
import ShortDeckHandRange from '@/components/short-deck/short-deck-hand-range';
import FiveCardHandsSection from '@/components/five-card-hands-section/five-card-hands-section';
import SimulateButton from '@/components/controls/simulate-button';
import FiveCardHandsSectionAlerts from '@/components/five-card-hands-section/alerts';
import ValueToBluffRatio from '@/components/hand-range/value-to-bluff-ratio';

export default {
  name: 'short-deck-range-for-street',
  components: {
    'short-deck-hand-range': ShortDeckHandRange,
    'five-card-hands-section': FiveCardHandsSection,
    'simulate-button': SimulateButton,
    'five-card-hands-section-alerts': FiveCardHandsSectionAlerts,
    'value-to-bluff-ratio': ValueToBluffRatio,
  },
  props: [
    'player',
    'playerIndex',
    'playerStateIndex',
    'presetCommunityCards',
    'presetHoleCards',
    'textWhenFiveCardHandPercentagesArentUpToDate',
    'storeModuleName',
    'simulateButton',
    'authorized',
  ],
  computed: {
    handRankings: function () {
      return this.$store.getters['account/handRankings'];
    },
    disableAllSelectors: function () {
      if (!this.authorized) {
        return true;
      }
      
      if (this.playerStateIndex === 0) {
        return false;
      }

      return !this.presetCommunityCards.areAllCardsSet(this.playerStateIndex);
    },
  },
  methods: {
    handleFiveCardHandMouseover: function (storeModuleName, $store, playerIndex, playerStateIndex, e) {
      if (!this.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        return;
      }

      this.player.handleFiveCardHandMouseover(storeModuleName, $store, playerIndex, playerStateIndex, e)
    },
    handleFiveCardHandMouseleave: function (storeModuleName, $store, playerIndex, playerStateIndex) {
      if (!this.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        return;
      }

      this.player.handleFiveCardHandMouseleave(storeModuleName, $store, playerIndex, playerStateIndex);
    },
    resetDoubleSlider: function (playerIndex) {
      if (this.$refs['player-' + playerIndex + '-0']) {
        this.$refs['player-' + playerIndex + '-0'].resetDoubleSlider();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .panel-footer {
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/short-deck/short-deck-range-for-street.vue